import { NgModule } from '@angular/core';
import { LegfiDatePipeModule } from '../../../../../pipes/format/legfi-date.module';
import { OwnerSelectorModule } from '../../../shared/owner-selector/owner-selector.module';
import { EmailSenderDialogComponent } from './email-sender-dialog.component';
import { SharedModule } from '../../../../shared/shared.module';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { FileUploadModule } from 'ng2-file-upload';
import { RichTextEditorModule } from '../../../../shared/rich-text-editor/rich-text-editor.module';

@NgModule({
    imports: [
        SharedModule,
        MatDialogModule,
        LegfiDatePipeModule,
        OwnerSelectorModule,
        MatTableModule,
        MatSortModule,
        MatCheckboxModule,
        MatRadioModule,
        FileUploadModule,
        RichTextEditorModule,
    ],
    declarations: [EmailSenderDialogComponent],
    exports: [EmailSenderDialogComponent],
    providers: [],
})
export class EmailSenderDialogModule
{
}
